import script from "./projectIndetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./projectIndetail.vue?vue&type=script&lang=ts&setup=true"

import "./projectIndetail.vue?vue&type=style&index=0&id=2cad72bf&lang=scss&scoped=true"

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cad72bf"]])

export default __exports__